import { render, staticRenderFns } from "./ServicesGroupAdd.vue?vue&type=template&id=0be4dc2c&scoped=true"
import script from "./ServicesGroupAdd.vue?vue&type=script&lang=js"
export * from "./ServicesGroupAdd.vue?vue&type=script&lang=js"
import style0 from "./ServicesGroupAdd.vue?vue&type=style&index=0&id=0be4dc2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4dc2c",
  null
  
)

export default component.exports